<style>
#profileSWModal .v--modal-box.v--modal {
  min-height: 280px !important;
  min-width: 420px !important;
}
.modal__content {
  padding-top: 5px;
}
#profileSWModal .v-input--selection-controls {
  margin-top: 5px;
}
#profileSWModal .v-input--selection-controls.v-input .v-label {
  font-size: 12px;
}
#profileSWModal :not(.v-icon) {
  font-size: 12px;
}
#profileSWModal .input__wrapper {
  justify-content: space-evenly;
}
#profileSWModal .error__wrapper {
  justify-content: center;
}
#profileSWModal .error__text {
  text-align: center;
  color: white;
  font-size: 14px;
}
#profileSWModal .error__card {
  background-color: red;
  width: 100%;
}
#profileSWModal .line {
  width: 20px;
  height: 6px;
  display: inline-block;
}
#profileSWModal {
  justify-content: center;
  justify-items: center;
  align-items: center;
}
#profileSWModal .legend__wrapper--lines {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
#profileSWModal .legend__wrapper {
  align-items: center;
}
#profileSWModal .greenLine {
  background-color: #80ca11;
}
#profileSWModal .blackLine {
  background-color: black;
}
#profileSWModal .geometry__wrapper {
  line-height: 40px;
  justify-content: space-around;
}
#profileSWModal .profileList {
  width: 100%;
  margin-bottom: 10px;
}
#profileSWModal .v-list__tile__title {
  text-align: center;
}
#profileSWModal .geometry__wrapper span {
  text-transform: uppercase;
}
#profileSWModal .geometry__wrapper .flex {
  align-items: center;
  display: flex;
}
#profileSWModal .v-list {
  padding: 0px;
  border: 1px solid lightgray;
}
#profileSWModal .border--left {
  border-left: 1px solid lightgray;
}
</style>

<template>
  <Modal
    modalName="profileSWModal"
    title="Profil podłużny"
    :buttons="['save']"
    @saved="save()"
    @closed="closed()"
  >
    <v-form
      v-model="valid"
      ref="form"
    >
      <v-layout>
        <v-layout
          xs5
          class="input__wrapper"
        >
          <v-flex xs7>
            <v-text-field
              @input="setFeature(true)"
              label="Węzeł początkowy"
              height="16"
              v-model="payload.start"
              :rules="isRules"
              @click="selectNewObject(true)"
              type="number"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs1>
            <v-icon
              small
              class="btn__subheader"
              title="Przybliż do obiektu"
              @click="zoomToObject(startObject, true)"
            >
              fas fa-search-plus
            </v-icon>
          </v-flex>
        </v-layout>
        <v-spacer />
        <v-layout
          xs5
          class="input__wrapper"
        >
          <v-flex xs7>
            <v-text-field
              @input="setFeature(false)"
              label="Węzeł końcowy"
              height="16"
              v-model="payload.end"
              :rules="isRules"
              @click="selectNewObject(false)"
              type="number"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs1>
            <v-icon
              small
              class="btn__subheader"
              title="Przybliż do obiektu"
              @click="zoomToObject(endObject, false)"
            >fas fa-search-plus
            </v-icon>
          </v-flex>
        </v-layout>
      </v-layout>
    </v-form>
    <v-layout v-show="photo">
      <v-list class="profileList">
        <v-list-tile class="list--el">
          <v-list-tile-title class="list--el--bold">Wysokość początku przekroju [m]</v-list-tile-title>
          <v-list-tile-title class="border--left list--el--bold">Wysokość końca przekroju [m]</v-list-tile-title>
          <v-list-tile-title class="border--left list--el--bold">Średni spadek wysokości [°]</v-list-tile-title>
        </v-list-tile>
        <template v-for="(row, index) in profileData">
          <v-list-tile
            class="list--el"
            :key="index"
            style="border:none"
          >
            <v-list-tile-title>{{row.start}}</v-list-tile-title>
            <v-list-tile-title class="border--left">{{row.end}}</v-list-tile-title>
            <v-list-tile-title class="border--left">{{row.slope}}</v-list-tile-title>

          </v-list-tile>
        </template>
      </v-list>
    </v-layout>
    <v-layout>
      <v-layout v-if="photo">
        <v-flex>
          <v-layout>
            <img
              height="450px;"
              width="800px;"
              :src="photo"
            />
            <v-flex class="legend__wrapper--lines">
              <span>
                <div class="line greenLine"></div> - poziom terenu
              </span>
              <span>
                <div class="line blackLine"></div> - przebieg przewodów
              </span>

            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout
        class="error__wrapper"
        v-else
      >
        <v-card
          v-if="error"
          class="error__card"
        >
          <v-card-text class="error__text">
            {{error}}
          </v-card-text>
        </v-card>
        <!-- <span v-text="error">
        </span> -->
      </v-layout>
    </v-layout>
  </Modal>
</template>

<script>
import Modal from "../../../shared/Modal";

import chain from "lodash/chain";
import value from "lodash/value";
import mixin from "lodash/mixin";
import _ from "lodash/wrapperLodash";
import set from "lodash/set";
import get from "lodash/get";
import has from "lodash/has";
import includes from "lodash/includes";
import map from "lodash/map";
import each from "lodash/each";
import some from "lodash/some";
import filter from "lodash/filter";
import find from "lodash/find";
mixin(_, {
  get: get,
  set: set,
  has,
  getOrSet(object, path, defaultValue) {
    if(!_.has(object, path)) {
      object = _.set(object, path, defaultValue);
    }
    return _.get(object, path, defaultValue);
  },
  includes,
  map,
  some,
  find,
  each,
  filter,
  chain
});
_.value = value;
_.prototype.value = value;

export default {
  components: {
    Modal
  },
  props: {
  },
  data: () => ({
    payload: {
      start: "",
      end: ""
    },
    profileData: [{
      start: 'Brak danych',
      end: 'Brak danych',
      slope: 'Brak danych',
    }],
    error: "",
    photo: "",
    valid: false,
    isRules: [v => !!v || "Wybierz węzeł"],
    layer: "",
  }),
  computed: {
    map() {
      return this.$store.getters.getMap;
    },
  },
  methods: {
    save() {
      if(this.$refs.form.validate()) {
        if(this.layer === "junctions") {
          this.$store.dispatch("getWatersProfile", this.payload).then(success => {
            if(success.status === 200) {
              this.photo = "data:image/png;base64," + success.data.data;
              this.profileData[0] = {
                start: success.data.start_height.toFixed(2),
                end: success.data.end_height.toFixed(2),
                slope: this.calcSlope(success.data.start_height, success.data.end_height, success.data.total_length).toFixed(2)
              }
            } else {
              this.photo = "";
              this.error = success;
              // this.$root.$emit("showSnackbar", "red", `${success}`, 5000, true);
            }
          })
        } else {
          this.$store.dispatch("getSewersProfile", this.payload).then(success => {
            if(success.status === 200) {
              this.photo = "data:image/png;base64," + success.data.data;
              this.profileData[0] = {
                start: success.data.start_height.toFixed(2),
                end: success.data.end_height.toFixed(2),
                slope: this.calcSlope(success.data.start_height, success.data.end_height, success.data.total_length).toFixed(2)
              }
            } else {
              this.photo = "";
              this.error = success;
              // this.$root.$emit("showSnackbar", "red", `${success}`, 5000, true);
            }
          })
        }
      }
    },
    fetchError() {
      this.photo = "";
    },
    calcSlope(start, end, length) {
      // Zwraca spadek wysokości między punktem początkowym a końcowym w stopniach
      return Math.atan(
        Math.abs(start - end) / length
      ) * 180 / Math.PI;
    },
    closed() {
      this.payload = {};
      this.layer = "";
      this.photo = "";
      this.error = "";
      this.$root.$emit("clearSelectionFeatures");
      this.$root.$emit("disableSelectionElement");
      this.map.getViewport().style.cursor = "";
    },
    setFeature(isStart) {
      if(isStart) this.startObject = undefined;
      else this.endObject = undefined;
    },
    setProfileLayer(layer) {
      this.layer = layer;
    },
    zoomToObject(feature, isStart) {
      const self = this;
      if(!feature) {
        if(isStart) {
          this.$store.dispatch("getFeature", {
            object_table: self.layer,
            object_id: self.payload.start
          }).then(success => {
            self.startObject = success;
            self.$root.$emit("zoomToGeometry", self.startObject.getGeometry().transform(this.$store.getters.getSrid, "EPSG:2180"), {});
          });
        } else {
          this.$store.dispatch("getFeature", {
            object_table: self.layer,
            object_id: self.payload.end
          }).then(success => {
            self.endObject = success;
            self.$root.$emit("zoomToGeometry", self.endObject.getGeometry().transform(this.$store.getters.getSrid, "EPSG:2180"), {});
          });
        }
      } else {
        self.$root.$emit("zoomToGeometry", feature.getGeometry(), {});
      }
    },
    selectNewObject(isStart) {
      const self = this;
      self.$root.$emit(
        "showSnackbar",
        "#2a579a",
        "Kliknij na mapie, aby wybrać węzeł"
      );
      self.map.getViewport().style.cursor = "crosshair";
      self.$root.$once("selectionElementCallback", featuresLayers => {
        _.each(featuresLayers, featuresLayer => {
          //przeleć po warstwach
          // sprawdzenie czy wybrane ficzery pochodzą z odpowiedniej warstwy

          _.each(featuresLayer.features, feature => {
            //przeleć po elementach warstwy
            const id = feature.getId();
            if(isStart) {
              this.payload.start = feature.getId();
              this.startObject = feature;
            } else {
              this.payload.end = feature.getId();
              this.endObject = feature;
            }
          });
        });
        self.map.getViewport().style.cursor = "";
        self.$forceUpdate();
      });
      self.$root.$emit("enableSelectionElement", {
        layers: [self.layer],
        nearest: true
      });
    }
  },
  mounted() {
    this.startObject = undefined; //nie dawać w obserwer feature z OL jak już potrzeba to w Proxy
    this.endObject = undefined; //nie dawać w obserwer feature z OL jak już potrzeba to w Proxy
    this.$root.$on("setProfileLayer", this.setProfileLayer)
  },
  beforeDestroy() {
    this.$root.$emit("clearSelectionFeatures");
    this.$root.$emit("disableSelectionElement");
    this.map.getViewport().style.cursor = "";
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/analysis/modals/ProfileSW.vue